"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const constants_1 = require("@dzambalaorg/constants");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const provider_license_1 = require("@dzambalaorg/provider-license");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const AddressInput = (props) => {
    const { outlined = true } = props;
    const license = (0, provider_license_1.useLicense)();
    if (!license.isValid()) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Paper, { elevation: outlined ? 1 : 0, sx: theme => ({ px: outlined ? theme.tokens.spacing.xl : 0, py: theme.tokens.spacing.xl }), children: (0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: [2, 2, 2, 1], children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "addressLine1" }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "addressLine2" }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "city" }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "country", options: constants_1.EnabledCountries }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "state" }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "zip" }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SwitchInput, { name: "isDefault" })] }) }));
};
exports.AddressInput = AddressInput;
//# sourceMappingURL=index.js.map